import { render, staticRenderFns } from "./trainingProgInfo.vue?vue&type=template&id=72484c4a&scoped=true"
import script from "./trainingProgInfo.vue?vue&type=script&lang=js"
export * from "./trainingProgInfo.vue?vue&type=script&lang=js"
import style0 from "./trainingProgInfo.vue?vue&type=style&index=0&id=72484c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72484c4a",
  null
  
)

export default component.exports